import React, { useEffect, useRef, useState } from 'react'
import Button, { ButtonGroup } from 'components/Base/Button'
import VideoMask from 'components/VideoMask'
import classnames from 'classnames'
import { isPc } from 'utils/utils'

interface BannerProps {
  className?: string
  title?: string
  desc?: string
  left_button_text?: string
  left_button_link?: string
  right_button_text?: string
  right_button_link?: string
  right_img?: string
  right_img_alt?: string
  right_link?: string
  style?: React.CSSProperties
  curVideo?: any
  /**是否展示视频组件的遮罩层 如果没有就只展示图片 默认为true*/
  showMask?: boolean
}

const Banner: React.FC<BannerProps> = ({
  className,
  title,
  desc,
  left_button_text,
  left_button_link,
  right_button_text,
  right_button_link,
  right_img,
  right_img_alt,
  right_link,
  style = {},
  curVideo,
  showMask = true,
}) => {
  const bgRef = useRef(null)
  // 是否为PC端的标识
  const [isPcFlag, setIsPcFlag] = useState<boolean>(true)
  // 移动端图片高度
  const [imgHeight, setImgHeight] = useState(0)
  // 判断是否为PC端
  useEffect(() => {
    !isPc() && setIsPcFlag(false)
  }, [])
  // 获取banner背景图的宽度按16：9计算高度，防止图片比例变形
  useEffect(() => {
    const newWidth = bgRef.current?.offsetWidth / (16 / 9)
    setImgHeight(newWidth)
  }, [bgRef.current?.offsetWidth])
  return (
    <div className={classnames('lg:py-[100px] pt-[4rem] pb-[4rem]', className)} style={style}>
      <div className="lg:w-[1200px] lg:flex  mx-auto px-[2rem] lg:px-0 text-center lg:text-left">
        <div className="lg:flex-1 ">
          {title && (
            <h1 className="lg:leading-[62px] lg:text-[44px] text-[24px] leading-[34px] pt-[4.5rem] lg:pt-[62px] font-medium text-[#2c2c45]">
              {title}
            </h1>
          )}
          {desc && (
            <p className="lg:pt-[20px] pt-[1rem] text-[12px] lg:text-[16px] text-[#2c2c45] leading-[22px] lg:w-[514px]">
              {desc}
            </p>
          )}
          <ButtonGroup className="mt-[45px] lg:mt-[32px]">
            {left_button_text && (
              <Button btnType="primary" href={left_button_link} size="small" target="_blank">
                {left_button_text}
              </Button>
            )}
            {right_button_text && (
              <Button className="!ml-[16px] lg:!ml-[36px]" size="small" href={right_button_link} target="_blank">
                {right_button_text}
              </Button>
            )}
          </ButtonGroup>
        </div>
        <div
          className="lg:w-[586px] mt-[3.5rem] lg:mt-0 w-full lg:h-[330px] rounded-[4px] overflow-hidden"
          style={isPcFlag ? undefined : { height: imgHeight }}
          ref={bgRef}
        >
          {showMask ? (
            <VideoMask onClick={() => curVideo?.current?.playVideo()}>
              <img className="w-full h-full rounded-[4px]" src={right_img} alt={right_img_alt} />
            </VideoMask>
          ) : (
            <img className="w-full h-full rounded-[4px]" src={right_img} alt={right_img_alt} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Banner
